import { ProductViewer } from './ProductViewer.js';

window.customElements.define('product-viewer', ProductViewer);
